import React from 'react';


const StarRating = () => {
    return (
        <div className="star-rating">
            <span className="star full">★</span>
            <span className="star full">★</span>
            <span className="star full">★</span>
            <span className="star full">★</span>
            <span className="star half">★</span>
        </div>
    );
};

export default StarRating;
